module.exports = __webpack_public_path__ + "cce80bffb6f417ea7a8823e370dc980b.fbx";